import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
const items = ['Sei stanco di perdere ore ogni settimana a cercare materiali sparsi tra Pearson, Loescher e YouTube.', 'Arrivi a casa dopo una lunga giornata e devi ancora costruire la verifica per il giorno dopo.', 'Senti di spiegare sempre gli stessi autori nello stesso modo e i tuoi studenti hanno smesso di appassionarsi.', 'Hai bisogno di una programmazione professionale e allineata al MIM, non un documento improvvisato.', "Vuoi un sistema completo che copra tutto l'anno — dal biennio al triennio, dalle Origini alla Maturità.", 'Hai studenti con livelli diversi (BES, DSA, plusdotati, alunni L2) e non sai come differenziare senza moltiplicare il tuo lavoro.', "Vuoi entrare in classe sicuro, preparato e con l'autorevolezza che un Docente di Lettere merita davvero."];
export function ForYouChecklist() {
  return <section className="py-10 sm:py-12 px-4 bg-brand-card/50 border-y border-brand-orange/10 relative" data-id="element-109">
      <div className="max-w-4xl mx-auto" data-id="element-110">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl sm:text-4xl font-black text-center mb-10 uppercase text-brand-cream" data-id="element-111">
          Questo sistema è per te se...
        </motion.h2>

        <div className="space-y-4" data-id="element-112">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex gap-4 items-start bg-brand-dark p-5 rounded-xl border border-white/5 hover:border-brand-orange/30 transition-colors" data-id="element-113">
              <CheckCircle2Icon className="w-6 h-6 sm:w-8 sm:h-8 text-green-500 shrink-0 mt-0.5" data-id="element-114" />
              <p className="text-base sm:text-lg text-gray-200 font-medium leading-relaxed" data-id="element-115">
                {item}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}